import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from 'src/app/core/api/user/user.service';
import { RegionsCount } from 'src/app/shared/models/dtos/responses/regions-count/regions-count';

@Injectable({
  providedIn: 'root',
})
/**
 * Service used to interact with current authenticated user
 */
export class RegionalAdminService {
  private _voidRegions?: any[];
  voidRegions$ = new BehaviorSubject<any | undefined>(undefined);

  /**
   * @constructor
   */
  constructor(private readonly userService: UserService) {}

  /**
   * @param {AdministratorDTO | undefined } value
   */
  set voidRegions(value: any | undefined) {
    this._voidRegions = value;
    this.voidRegions$.next(value);
  }

  /**
   * Gets admin
   */
  get voidRegions() {
    return this._voidRegions;
  }

  /**
   * call user service
   */
  getRegionalAdminCount() {
    this.userService
      .countRegionalAdmins()
      .subscribe((count: RegionsCount[]) => {
        this.getRegions(count);
      });
  }

  /**
   * Return an array of regions without regional admins
   * @param {any} count
   * @return {any}
   */
  private getRegions(count: RegionsCount[]): any {
    this.voidRegions = count
      .filter((item) => item.count === 0)
      .map((item) => item.region);

    return this.voidRegions;
  }
}
